import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";

import { all_routes } from "../router/all_routes";
import SearchBy from "./searchBy";
import SectionBenefit from "./sectionBenefit";
import PlaceSections from "./placeSection";
import AboutSection from "./about-section";
import ExpertSection from "./experts-section";
import TestimonialSection from "./testimonialSection";
import UpdateSection from "./updateSection";
import FlightSearch from "../flight/flightSearch";
import { usePacote } from "../../core/common/PacoteContext/PacoteContext";
import ExploreCitiesSection from "./ExploreCitiesSection";
import {t} from "../../lang/index"

const HomeOne = () => {
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_URL;
  const { setPacotes } = usePacote();

  const sliderRef = useRef<Slider>(null);

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    arrows: false,
    speed: 1000,
    cssEase: "ease-in-out",
  };

  // Autoplay vertical
  useEffect(() => {
    const interval = setInterval(() => {
      sliderRef.current?.slickNext();
    }, 9000);
    return () => clearInterval(interval);
  }, []);

  const [servicoId, setServicoId] = useState<number | null>(null);

  // Carregar serviço Tuk Tuk e preferências do usuário
  useEffect(() => {
    AOS.init({ duration: 1000 });

    const token = localStorage.getItem("token");

    // Buscar serviços
    fetch(`${BASE_URL}/servicos`)
      .then((res) => res.json())
      .then((servicosData) => {
        // Filtra apenas Tuk Tuk
        const tukTuk = servicosData.find((s: any) =>
          s.nome.toLowerCase().includes("tuk tuk")
        );

        if (!tukTuk) {
          console.error("Serviço Tuk Tuk não encontrado no backend!");
          return;
        }

        // Se tiver token, tenta buscar preferências do usuário
        if (token) {
          fetch(`${BASE_URL}/preferencias`, {
            headers: { Authorization: `Bearer ${token}` },
          })
            .then((res) => res.json())
            .then((prefsData) => {
              if (prefsData?.servicoId === tukTuk.id) {
                setServicoId(tukTuk.id);
              } else {
                // Fallback para Tuk Tuk
                setServicoId(tukTuk.id);
              }
            })
            .catch(() => {
              // Se erro, também usar Tuk Tuk
              setServicoId(tukTuk.id);
            });
        } else {
          // Sem token: apenas Tuk Tuk
          setServicoId(tukTuk.id);
        }
      })
      .catch((err) => console.error("Erro ao carregar serviços:", err));
  }, [BASE_URL]);

  const handleSearch = async (valores: {
    termo?: string;
    idioma?: string;
    data?: string;
    hora?: string;
    pessoas?: number;
  }) => {
    try {
      const params = new URLSearchParams();
      if (valores.termo) params.append("termo", valores.termo);
      if (valores.idioma) params.append("idioma", valores.idioma);
      if (valores.data) params.append("data", valores.data);
      if (valores.hora) params.append("hora", valores.hora);
      if (valores.pessoas) params.append("pessoas", valores.pessoas.toString());
      if (servicoId) params.append("servicoId", servicoId.toString());

      const res = await fetch(`${BASE_URL}/pacotes/search?${params.toString()}`);
      if (!res.ok) throw new Error("Erro na pesquisa");

      const result = await res.json();
      setPacotes(result);
      navigate(all_routes.flightGrid);
    } catch (err) {
      console.error("Erro ao buscar pacotes:", err);
    }
  };

  return (
    <>
      {/* Hero Section */}
      <section className="hero-section">
        <Slider ref={sliderRef} {...settings} className="banner-slider banner-sec owl-carousel">
          <div className="slider-img">
            <img src="assets/img/HOME/banner1.jpg" alt="Img" />
          </div>
          <div className="slider-img">
            <img src="assets/img/HOME/banner2.jpg" alt="Img" />
          </div>
          <div className="slider-img">
            <img src="assets/img/HOME/banner3.jpg" alt="Img" />
          </div>
          <div className="slider-img">
            <img src="assets/img/HOME/banner4.jpg" alt="Img" />
          </div>
        </Slider>

        <div className="container">
          <div className="hero-content">
            <div className="row align-items-center">
              <div className="col-md-12 mx-auto aos fadeInUp" data-aos="fade-up">
                <div className="banner-content mx-auto">
                  <h1 className="text-white display-5 mb-2">
                    {t("home.hero.title")}<span>{t("home.hero.title2")}</span>{t("home.hero.title3")}
                  </h1>
                  <h6 className="text-light mx-auto">
                    {t("home.hero.subtitle")}
                  </h6>
                </div>

                {/* FORM Tuk Tuk */}
                {servicoId && (
                  <div className="banner-form card mb-0">
                    <div className="card-header">
                      <ul className="nav">
                        <li>
                          <Link
                            to="#"
                            className="nav-link active"
                            onClick={() => setServicoId(servicoId)}
                          >
                            Tuk Tuk
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="card-body">
                      <FlightSearch mostrarTodosFiltros={true} onSearch={handleSearch} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Hero Section */}

      <SearchBy />
      <SectionBenefit />
      <ExploreCitiesSection servicoId={servicoId ?? undefined} />
      <PlaceSections />
      <AboutSection />
      <ExpertSection />
      <TestimonialSection />
      <UpdateSection />
    </>
  );
};

export default HomeOne;